/* MFTC extreme low engine. Montana Fruit Trees.
   The same math the Cold Hardiness Calculator page runs, packaged so the Plant
   Finder on every collection page can use it. Address in, coldest night to plan
   for out: the 1-in-30-year low from nearby long record stations, weighted by
   distance, elevation match and length of record, then adjusted for the lay of
   the land and what the customer tells us about their ground. */
(function () {
  'use strict';
  var Z = 12, TS = 256, RAD = Math.PI / 180, M2 = 3.28084, TC = {}, ZIPP = {};

  /* Zone notation: a bare number means the whole zone, "b" the warmer half. Never print "a". */
  function zone(T) { var n = Math.floor((T + 60) / 10) + 1, r = (((T + 60) % 10) + 10) % 10; return n + (r >= 5 ? 'b' : ''); }
  function zlab(T) { return T < -60 ? 'Colder than zone 1' : 'Zone ' + zone(T); }

  function geo(a) {
    return new Promise(function (res) {
      var cb = '__mx' + Math.random().toString(36).slice(2), done = false, s = document.createElement('script');
      window[cb] = function (d) {
        var m = d && d.result && d.result.addressMatches && d.result.addressMatches[0];
        try { s.remove(); } catch (e) {}
        if (done) return;
        done = true;
        res(m ? {lat: m.coordinates.y, lon: m.coordinates.x, label: m.matchedAddress, zip: (String(m.matchedAddress).match(/(\d{5})(?:-\d{4})?\s*$/) || [])[1]} : null);
      };
      s.src = 'https://geocoding.geo.census.gov/geocoder/locations/onelineaddress?address=' + encodeURIComponent(a) + '&benchmark=Public_AR_Current&format=jsonp&callback=' + cb;
      s.onerror = function () { if (!done) { done = true; res(null); } };
      document.head.appendChild(s);
      setTimeout(function () { if (!done) { done = true; res(null); } }, 9000);
    });
  }

  function geo2(a) {
    return fetch('https://photon.komoot.io/api/?limit=1&q=' + encodeURIComponent(a))
      .then(function (r) { return r.json(); }).then(function (j) {
        var f = j.features && j.features[0]; if (!f) return null;
        var p = f.properties || {}, nm = [p.name, p.city, p.state].filter(Boolean).join(', ');
        var z = String(p.postcode || '').match(/^\d{5}/);
        return {lat: f.geometry.coordinates[1], lon: f.geometry.coordinates[0], label: nm || a, zip: z ? z[0] : null};
      }).catch(function () { return null; });
  }

  /* Official 2023 USDA zone for the ZIP, from the table we already host, for the side by side. */
  function usda(zip, url) {
    if (!zip || !url) return Promise.resolve(null);
    if (!ZIPP[url]) {
      ZIPP[url] = fetch(url).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (Z2) {
        var idx = {}, prev = 0, parts = Z2.enc.split(' ');
        for (var i = 0; i < parts.length; i++) {
          var q = parts[i].split('.'), st = prev + parseInt(q[0], 36), l = parseInt(q[1], 36), k = parseInt(q[2], 36);
          for (var j = 0; j < l; j++) idx[st + j] = k;
          prev = st + l;
        }
        return {Z: Z2, idx: idx};
      }).catch(function () { delete ZIPP[url]; return null; });
    }
    return ZIPP[url].then(function (d) {
      if (!d) return null;
      var k = d.idx[parseInt(zip, 10)];
      if (k === undefined) return null;
      return {zone: String(d.Z.zones[k]).replace(/a$/, ''), tr: d.Z.tr ? d.Z.tr[k] : ''};
    });
  }

  function tile(tx, ty) {
    var k = tx + '_' + ty; if (TC[k]) return Promise.resolve(TC[k]);
    return fetch('https://elevation-tiles-prod.s3.amazonaws.com/terrarium/' + Z + '/' + tx + '/' + ty + '.png')
      .then(function (r) { if (!r.ok) throw 0; return r.blob(); }).then(createImageBitmap).then(function (bm) {
        var oc = new OffscreenCanvas(TS, TS), cx = oc.getContext('2d', {willReadFrequently: true}); cx.drawImage(bm, 0, 0);
        var d = cx.getImageData(0, 0, TS, TS).data, a = new Int16Array(TS * TS);
        for (var i = 0, j = 0; i < d.length; i += 4, j++) a[j] = Math.round((d[i] * 256 + d[i + 1] + d[i + 2] / 256) - 32768);
        TC[k] = a; return a;
      });
  }

  function win(lat, lon, N) {
    var n = Math.pow(2, Z) * TS, si = Math.sin(lat * RAD);
    var px = Math.round((lon + 180) / 360 * n), py = Math.round((0.5 - Math.log((1 + si) / (1 - si)) / (4 * Math.PI)) * n);
    var mpp = 156543.03392 * Math.cos(lat * RAD) / Math.pow(2, Z), h = N >> 1, x0 = px - h, y0 = py - h, jobs = [], tl = {};
    for (var tx = Math.floor(x0 / TS); tx <= Math.floor((x0 + N - 1) / TS); tx++)
      for (var ty = Math.floor(y0 / TS); ty <= Math.floor((y0 + N - 1) / TS); ty++)
        (function (a, b) { jobs.push(tile(a, b).then(function (z) { tl[a + '_' + b] = z; })); })(tx, ty);
    return Promise.all(jobs).then(function () {
      var E = new Float32Array(N * N);
      for (var j = 0; j < N; j++) {
        var gy = y0 + j, t2 = Math.floor(gy / TS), ry = (((gy % TS) + TS) % TS) * TS;
        for (var i = 0; i < N; i++) { var gx = x0 + i, ar = tl[Math.floor(gx / TS) + '_' + t2]; E[j * N + i] = ar ? ar[ry + (((gx % TS) + TS) % TS)] : 0; }
      }
      return {E: E, N: N, mpp: mpp, c: h * N + h};
    });
  }

  function terr(lat, lon) {
    return win(lat, lon, 256).then(function (w) {
      var E = w.E, N = w.N, c = w.c, mpp = w.mpp, s = E[c], cx = c % N, cy = (c / N) | 0;
      var a10 = s - 10 / M2, a25 = s - 25 / M2, a50 = s - 50 / M2, d10 = null, d25 = null, d50 = null, half = (N >> 1) - 1;
      for (var r = 1; r <= half; r++) {
        var pts = Math.max(8, Math.round(6.3 * r)), h1 = false, h2 = false, h5 = false;
        for (var a = 0; a < pts; a++) {
          var th = 2 * Math.PI * a / pts, x = Math.round(cx + r * Math.cos(th)), y = Math.round(cy + r * Math.sin(th));
          if (x < 0 || y < 0 || x >= N || y >= N) continue;
          var e = E[y * N + x];
          if (e <= a50) { h5 = h2 = h1 = true; break; }
          if (e <= a25) { h2 = h1 = true; } else if (e <= a10) { h1 = true; }
        }
        var km = r * mpp / 1000;
        if (d10 === null && h1) d10 = km; if (d25 === null && h2) d25 = km; if (d50 === null && h5) d50 = km;
        if (d50 !== null) break;
      }
      var cap = half * mpp / 1000, below = 0, mn = 1e9, mx = -1e9;
      for (var k = 0; k < N * N; k++) { var v = E[k]; if (v < s) below++; if (v < mn) mn = v; if (v > mx) mx = v; }
      var hs = 0;
      for (var az = 0; az < 12; az++) {
        var an = 2 * Math.PI * az / 12, ux = Math.cos(an), uy = Math.sin(an), bst = 0;
        for (var rr = 3; rr * mpp < 3000; rr += 3) {
          var xx = Math.round(cx + ux * rr), yy = Math.round(cy + uy * rr);
          if (xx < 0 || yy < 0 || xx >= N || yy >= N) break;
          var g = (E[yy * N + xx] - s) / (rr * mpp); if (g > bst) bst = g;
        }
        hs += bst;
      }
      return {dd50: d50 === null ? cap : d50, pctBelow: Math.round(100 * below / (N * N)), horizon: hs / 12, reliefFt: (mx - mn) * M2, elevFt: Math.round(s * M2)};
    });
  }

  function adjOf(f) { var flat = f.reliefFt < 300 ? 1 : 0, d = Math.min(f.dd50, 3); return -3.5714 + 0.0547 * f.pctBelow - 0.1931 * d + 0.5496 * d * flat - 1.3576 * flat + 7.5969 * f.horizon; }
  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }
  function wmed(p) {
    var q = p.slice().sort(function (a, b) { return a[1] - b[1]; });
    var T = q.reduce(function (a, b) { return a + b[0]; }, 0), c = 0;
    for (var i = 0; i < q.length; i++) { c += q[i][0]; if (c >= T / 2) return q[i][1]; }
    return q[q.length - 1][1];
  }
  function huber(p) {
    var m = wmed(p);
    for (var it = 0; it < 12; it++) {
      var dev = p.map(function (x) { return Math.abs(x[1] - m); }).sort(function (a, b) { return a - b; });
      var mad = Math.max(dev[dev.length >> 1], 2) * 1.4826, W = 0, s = 0;
      p.forEach(function (x) { var r = Math.abs(x[1] - m) / mad, k = r <= 1.345 ? 1 : 1.345 / r; W += x[0] * k; s += x[1] * x[0] * k; });
      var nm = s / W; if (!isFinite(nm)) return m;
      if (Math.abs(nm - m) < 0.01) { m = nm; break; }
      m = nm;
    }
    return m;
  }

  function stns(lat, lon, dg) {
    var b = {bbox: (lon - dg) + ',' + (lat - dg) + ',' + (lon + dg) + ',' + (lat + dg), sdate: '1995-07', edate: '2026-06',
      elems: [{name: 'mint', interval: 'mly', duration: 'mly', reduce: 'min', maxmissing: 6}], meta: ['name', 'll', 'elev']};
    return fetch('https://data.rcc-acis.org/MultiStnData', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(b)})
      .then(function (r) { return r.json(); }).then(function (j) {
        var o = [];
        (j.data || []).forEach(function (s) {
          if (!s.meta || !s.meta.ll) return;
          var mo = (s.data || []).map(function (x) { var q = Array.isArray(x) ? x[0] : x, n = parseInt(q, 10); return isNaN(n) ? null : n; });
          /* one value per winter: coldest month low Nov-Mar, only if Dec, Jan and Feb are all complete */
          var v = [];
          for (var y = 0; y * 12 + 8 < mo.length; y++) {
            var w = mo.slice(y * 12 + 4, y * 12 + 9);
            if (w[1] === null || w[2] === null || w[3] === null) continue;
            v.push(Math.min.apply(null, w.filter(function (x) { return x !== null; })));
          }
          v = v.filter(function (x) { return x > -95 && x < 60; });
          if (v.length < 10) return;
          var n = v.length, m = v.reduce(function (a, c) { return a + c; }, 0) / n;
          var sd = Math.sqrt(v.reduce(function (a, x) { return a + (x - m) * (x - m); }, 0) / (n - 1));
          if (!(sd > 0.5)) return;
          var bb = sd * Math.sqrt(6) / Math.PI, mu = (-m) - 0.5772 * bb;
          o.push({name: s.meta.name, lat: s.meta.ll[1], lon: s.meta.ll[0], elev: s.meta.elev || null, n: n, MAM: m, sd: sd, rl30: -(mu - bb * Math.log(-Math.log(1 - 1 / 30)))});
        });
        return o;
      });
  }

  /* The answer moves with the ground question without pulling anything again. */
  function settle(r, ex) {
    ex = +ex || 0;
    var raw = r.base + ex;
    r.ex = ex;
    r.capped = raw > r.ceiling;
    r.est = r.capped ? r.ceiling : raw;
    r.zone = zlab(Math.round(r.est)); // label the same whole degree we show and filter on
    return r;
  }

  function lookup(a, ex, step, opt) {
    step = step || function () {}; opt = opt || {};
    a = String(a || '').trim();
    var bare = /^\d{5}$/.test(a), site = null, use = null, sf = null;
    step('Finding your address');
    return geo(a).then(function (g) { return g || geo2(bare ? a + ', USA' : a); }).then(function (g) {
      if (!g) throw new Error("We couldn't find that address. Try adding the city and state.");
      site = g;
      if (!site.zip) { var zm = a.match(/\b(\d{5})(?:-\d{4})?\s*$/); if (zm) site.zip = zm[1]; }
      step('Pulling weather station records');
      var dg = 0.25;
      function t() { return stns(site.lat, site.lon, dg).then(function (s) { if (s.length >= 6 || dg > 1.2) return s; dg += 0.25; return t(); }); }
      return t();
    }).then(function (s) {
      if (!s.length) throw new Error("We couldn't find any long record weather stations near there. This only covers the United States.");
      var R = 6371;
      s.forEach(function (x) {
        var dla = (x.lat - site.lat) * RAD, dlo = (x.lon - site.lon) * RAD, la = (x.lat + site.lat) / 2 * RAD, q = dlo * Math.cos(la);
        x.dkm = Math.sqrt(dla * dla + q * q) * R;
      });
      s.sort(function (p, q) { return p.dkm - q.dkm; });
      use = s.slice(0, 8);
      step('Reading the lay of your land');
      return terr(site.lat, site.lon).then(function (f) {
        sf = f;
        return Promise.all(use.map(function (x) { return terr(x.lat, x.lon).then(function (f2) { x.adj = adjOf(f2); }); }));
      }).catch(function () { sf = null; use.forEach(function (x) { x.adj = 0; }); });
    }).then(function () {
      var siteEl = sf ? sf.elevFt : null;
      use.forEach(function (x) {
        var de = (x.elev == null || siteEl == null) ? 0 : (x.elev - siteEl);
        x.w = 1 / Math.pow(Math.max(x.dkm, 2), 1.5) * Math.exp(-Math.pow(de / 600, 2)) * (x.n / (x.n + 12));
      });
      var Wt = use.reduce(function (a2, x) { return a2 + x.w; }, 0);
      use.forEach(function (x) { x.wpct = Math.round(100 * x.w / Wt); });
      var rl = huber(use.map(function (x) { return [x.w, x.rl30]; }));
      var mam = huber(use.map(function (x) { return [x.w, x.MAM]; }));
      var sdw = use.reduce(function (a2, x) { return a2 + x.sd * x.w; }, 0) / Wt;
      var adj = sf ? clamp(adjOf(sf) - use.reduce(function (a2, x) { return a2 + x.adj * x.w; }, 0) / Wt, -6, 6) : 0;
      var spr = Math.sqrt(use.reduce(function (a2, x) { return a2 + x.w * Math.pow(x.rl30 - rl, 2); }, 0) / Wt);
      var wkm = use.reduce(function (a2, x) { return a2 + x.w * x.dkm; }, 0) / Wt, why = [];
      var top = use.slice().sort(function (p, q) { return q.w - p.w; })[0];
      if (wkm > 35) why.push('the stations that count most are about ' + Math.round(wkm * 0.621) + ' miles away on average');
      if (spr > 5) why.push('the nearby stations disagree with each other by about ' + Math.round(spr) + '°F');
      if (top && top.wpct > 60 && top.n < 15) why.push('it leans mostly on one station with only ' + top.n + ' good winters on file');
      if (use.length < 3) why.push('there are only ' + use.length + ' usable stations nearby');
      if (!sf) why.push("we couldn't read the terrain around you");
      var out = {label: site.label, zip: site.zip || null, base: rl + adj, ceiling: mam - 1.5 * sdw, avg: mam, rl: rl, adj: adj,
        band: Math.sqrt(spr * spr + 6.4 * 6.4), why: why, elevFt: siteEl, stations: use.length};
      return usda(site.zip, opt.zips).then(function (u) { out.usda = u; return settle(out, ex); });
    });
  }

  window.MFTExtreme = {lookup: lookup, settle: settle, zone: zone, zlab: zlab};
})();
